export function resolveStyleGuideDraft({
  currentDraft,
  lastSyncedDisplay,
  nextDisplay,
  isReadOnlySudowriteStyle,
}) {
  if (isReadOnlySudowriteStyle) return nextDisplay;
  if (currentDraft === lastSyncedDisplay || currentDraft === nextDisplay) return nextDisplay;
  return currentDraft;
}
